<template>
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g :clip-path="`url(#clip${id})`">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 37C3 18.2223 18.2223 3 37 3C55.7777 3 71 18.2223 71 37C71 55.7777 55.7777 71 37 71C18.2223 71 3 55.7777 3 37ZM37 1C17.1177 1 1 17.1177 1 37C1 56.8823 17.1177 73 37 73C56.8823 73 73 56.8823 73 37C73 17.1177 56.8823 1 37 1ZM51.7071 28.7071C52.0976 28.3166 52.0976 27.6834 51.7071 27.2929C51.3166 26.9024 50.6834 26.9024 50.2929 27.2929L33 44.5858L24.7071 36.2929C24.3166 35.9024 23.6834 35.9024 23.2929 36.2929C22.9024 36.6834 22.9024 37.3166 23.2929 37.7071L32.2929 46.7071C32.6834 47.0976 33.3166 47.0976 33.7071 46.7071L51.7071 28.7071Z" fill="white"/>
        </g>
        <defs>
            <clipPath :id="`url(#clip${id})`">
                <rect width="74" height="74" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconDone',

    props: {
        className: [String, Array, Object],
        id: {
            type: String,
            default: '4'
        }
    }
};
</script>

<style lang="scss">
@import "Icons";
</style>
